export default __webpack_public_path__ + "static/lanternSofiLogo-4e4890bfb84af01ec5971f6d632c8e6e.svg";